import styled, { css } from 'styled-components';

export const InputTimeStyled = styled.input.attrs({ type: 'Time' })`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings['000']} ${theme.spacings[500]};
    border-radius: ${theme.radii[200]};
    border-color: ${theme.colors.grey[300]};
  `}
`;
